import type { MenuGroup, MenuItem, PopoverMenuGroup, ProductMenu } from '../types/menuModel.js';
import type { MenuGroupDef, MenuItemDef, PopoverMenuGroupDef, PopoverMenuItemDef, ProductMenuDef } from './type.js';

function _toPopoverMenuItem(def: PopoverMenuItemDef): MenuItem {
  return {
    name: def.name,
    label: def.label,
    path: def.path,
    options: def.options,
    condition: def.condition,
  };
}

function _toPopoverMenuGroup(def: PopoverMenuGroupDef): PopoverMenuGroup {
  return {
    name: def.name,
    label: def.label,
    items: Object.values(def.items).map(_toPopoverMenuItem),
  };
}

function _toMenuItem(def: MenuItemDef): MenuItem {
  return {
    name: def.name,
    icon: def.icon,
    label: def.label,
    path: def.path,
    options: def.options,
    condition: def.condition,
    popoverMenus: def.popoverMenus ? Object.values(def.popoverMenus).map(_toPopoverMenuGroup) : undefined,
  };
}

function _toMenuGroup(def: MenuGroupDef): MenuGroup {
  return {
    name: def.name,
    label: def.label,
    menus: Object.values(def.menus).map(_toMenuItem),
  };
}

export function toMenuData(def: ProductMenuDef): ProductMenu {
  return {
    name: def.product.name,
    icon: def.product.icon,
    label: def.product.label,
    description: def.product.description,
    condition: def.condition,
    menuGroups: def.menuGroups ? Object.values(def.menuGroups).map(_toMenuGroup) : [],
    ...(def.product.link ? { link: def.product.link } : {}),
  };
}
